<template>
    <div :style="{'height':clientHeight-90+'px'}">
        <div class="m-portlet m-b-10" :style="{'height':(80)+'px'}">
            <div class="m-portlet__body">
                <el-form label-width="100px" style="width: 1200px">
                    <el-row :gutter="10">
                        <el-col :span="6">
                            <el-form-item label="筛选仓库">
                                <el-select v-model="filter.storeId" placeholder="仓库"
                                           filterable remote
                                           :remote-method="handelSearchStore"
                                           @change="handleChange()">
                                    <el-option
                                            v-for="item in warehouses"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="筛选学生">
                                <el-select v-model="filter.studentId" placeholder="学生" clearable
                                           filterable remote
                                           :remote-method="handelSearchByStudentName"
                                           @change="handleList()">
                                    <el-option
                                            v-for="item in students"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="6">
                            <el-form-item label="筛选序列号">
                                <el-select v-model="filter.serialId" placeholder="序列号" clearable
                                           filterable remote
                                           :remote-method="handelSearchBySerialId"
                                           @change="handleList()">
                                    <el-option
                                            v-for="item in serials"
                                            :key="item.id"
                                            :label="item.serial_id"
                                            :value="item.serial_id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </div>
        <div class="m-portlet m-b-10" :style="{'height':(260)+'px'}">
            <div class="m-portlet__body" :style="{'height':250+'px'}" v-loading="loading">
                <el-row :gutter="10">
                    <el-col :span="16">
                        <el-table
                                :data="shops"
                                style="width: 100%"
                                size="middle"
                                :height="200"
                        >
                            <el-table-column prop="name" label="商品名"></el-table-column>
                            <el-table-column prop="totalRent" label="总出租"></el-table-column>
                            <el-table-column prop="totalReturn" label="总归还"></el-table-column>
                            <el-table-column prop="rent" label="出租中"></el-table-column>
                        </el-table>
                    </el-col>
                    <el-col :span="8">
                        <div style="position: absolute;top: 40%;right: 5%">
                            <el-button round @click="handleView()" type="primary" style="height: 50px;width: 150px">待还清单</el-button>
                        </div>

                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="m-portlet" :style="{'height':(clientHeight-460)+'px'}">
            <div class="m-portlet__body" :style="{'height':clientHeight-550+'px'}" v-loading="loading">
                <el-table
                        :data="orderLeaseInventory"
                        style="width: 100%"
                        size="middle"
                        :height="clientHeight-550"
                >
                    <el-table-column prop="shopName" label="商品名称" min-width="15%"></el-table-column>
                    <el-table-column prop="description" label="描述" min-width="10%"></el-table-column>
                    <el-table-column prop="serial_id" label="序列号" min-width="10%"></el-table-column>
                    <el-table-column prop="sign" label="内部编号" min-width="10%"></el-table-column>
                    <el-table-column prop="created_at" label="首次入库时间" min-width="15%"></el-table-column>
                    <el-table-column prop="invoice_id" label="所属合同" min-width="10%"></el-table-column>
                    <el-table-column prop="student_id" label="租赁人ID" min-width="10%"></el-table-column>
                    <el-table-column prop="name" label="租赁人" min-width="10%"></el-table-column>
                    <el-table-column prop="price" label="价值" min-width="10%"></el-table-column>
                    <el-table-column label="操作" min-width="20%">
                        <template slot-scope="scope">
                            <el-button size="mini"
                                       @click="handleAdd(scope.row.id)">加入待还清单
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="m-portlet__foot">
                    <!--分页-->
                    <div class="text-center">
                        <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '@/store'
    export default {
        name: "RentingList",
        data() {
            return {
                leaseInventory:[],
                shops:[],
                warehouses:[],
                students:[],
                serials:[],
                invoices:[],
                warehouse_id:'',
                filter:{
                    date:'',
                    serialId:'',
                    sign:'',
                    categoryId:'',
                    storeId:'',
                    name:'',
                    studentId:''
                },
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                loading:false,
                Dialogs_ReturnList:{
                    leaseInvoices:[],
                    multipleSelection:[],
                    total: 0,
                    currentPage: 1,
                    currentPageSize: 10,
                    filter:{
                        student_id:'',
                        invoice_id:''
                    }
                },
                Dialogs_ReturnConfirm: {
                    loading: false,
                    hasMoney: 0,
                    zfb: 0,
                    wetChat: 0,
                    bank: 0,
                    cash: 0,
                    discount: 0,
                    headTeacherLimit: 0,
                    periodUse: 0,
                    periodLklBank: 0,
                    periodLklWetChat: 0,
                    periodLklZfb: 0,
                    coupon: 0,
                    showOn: true,
                    printOn: true,
                    maxHeight: 800,
                },
                Dialogs_ReturnEquipment:{
                    dialogVisible:false,
                    filter:{
                        balanceType:'',
                        bank:'',
                        bankAccount:'',
                        accountName:'',
                        discountRent:'',
                        repairMoney:'',
                        repairContent:'',
                        account_bank:'',
                        guardianId:'',
                        guardianName:'',
                        guardianPhone:'',
                        discount_rent:'',
                        repair_balance:'',
                        repair_content:'',
                        totalRent:0,
                        balance:0
                    },
                    deposit:{
                        freeDay:'',
                        rentDay:'',
                        rent:'',
                        remainBalance:'',
                        overBalance:'',
                        payment:'',
                        borrow_date:'',
                        totalRent:0
                    },
                }
            }
        },
        created() {
            this.handleList()
            this.handleCountByShopName();
            this.handelSearchStore();
            this.handelSearchBySerialId();
            this.handelSearchByStudentName();
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            orderLeaseInventory: function () {
                return this._.orderBy(this.leaseInventory, 'id', 'asc');
            }
        },
        methods: {
            handleList(currentPage = 1){
                if (currentPage === 1) {
                    this.currentPage = 1
                }
                this.loading = true;
                this.$axios.get(store.state.server + '/getRentList?storeId=' + this.filter.storeId+
                    '&serialId='+this.filter.serialId +
                    '&studentId='+this.filter.studentId +
                    '&page='+this.currentPage +
                    '&currentPageSize=' + this.currentPageSize
                ).then((response) => {
                    if (response.data.code == '0000') {
                        if (Object.keys(response.data.content.list).length !== 0) {
                            this.leaseInventory=response.data.content.list
                        } else {
                            this.leaseInventory = new Object();
                        }
                        this.total=response.data.content.total
                        this.loading=false
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleCountByShopName(){
                this.$axios.get(store.state.server + '/rentCount?storeId=' + this.filter.storeId
                ).then((response) => {
                    if (response.data.code == '0000') {
                        this.shops=response.data.content.shopNames
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handleChange(){
                this.handleList();
                this.handleCountByShopName();
            },
            handleView(){
                this.$Win.openModal('Dialogs_ReturnList', 700, 400, '待还清单');
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.handleList(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.handleList(this.currentPage, this.currentPageSize)
            },
            handleAdd(ownerId){
                this.$axios.post (store.state.server + '/returnShop?',{
                        'ownerId':ownerId
                    }
                ).then((response) => {
                    if (response.data.code == '0000') {
                        this.$delete(this.leaseInventory,ownerId)
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handelSearchStore(val=''){
                this.$axios.get(store.state.server + '/searchByStoreName?storeName=' +val+'&type=2').then((response) => {
                    if (response.data.code == '0000') {
                        this.warehouses=response.data.content.storeName
                        if(!this.filter.storeId){
                            this.filter.storeId=this.warehouses[0].id
                            this.handleChange()
                        }
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handelSearchBySerialId(val=''){
                this.$axios.get(store.state.server + '/searchBySerialId?serialId=' +val).then((response) => {
                    if (response.data.code == '0000') {
                        this.serials=response.data.content.shops
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
            handelSearchByStudentName(val=''){
                this.$axios.get(store.state.server + '/searchByStudentName?studentName=' +val).then((response) => {
                    if (response.data.code == '0000') {
                        this.students=response.data.content.students
                    }
                }).catch((res) => {
                    this.$message({
                        type: 'error',
                        message: res.response.data.content
                    });

                })
            },
        }
    }
</script>

<style scoped>

</style>